import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from '../modules/breadcrumbs/breadcrumbs.enums';

interface ApplicationState {
  isAppInitialized: boolean;
  breadcrumbs: BreadcrumbName[];
}

const applicationInitialState: ApplicationState = {
  isAppInitialized: false,
  breadcrumbs: [],
};

const applicationSlice = createSlice({
  name: 'application',
  initialState: applicationInitialState,
  reducers: {
    setAppInitialized: (state, action: PayloadAction<boolean>) => {
      state.isAppInitialized = action.payload;
    },
    addBreadcrumb: (state, action: PayloadAction<BreadcrumbName>) => {
      if (state.breadcrumbs.includes(action.payload)) return;
      state.breadcrumbs.push(action.payload);
    },
    removeBreadcrumb: (state, action: PayloadAction<BreadcrumbName>) => {
      state.breadcrumbs = state.breadcrumbs.filter((breadcrumb) => breadcrumb !== action.payload);
    },
  },
});

const {setAppInitialized, addBreadcrumb, removeBreadcrumb} = applicationSlice.actions;

export {addBreadcrumb, setAppInitialized, removeBreadcrumb};

export default applicationSlice.reducer;
